// Keyboard-triggered quick-add row for task lists (plan rail uses AddTaskInputRow).
import TaskInputInline from '@/features/tasks/components/forms/TaskInputInline';
import { AddTaskInputRow } from '@/components/ui/AddTaskInputRow';

/**
 * @param {object} props
 * @param {(parsed: object) => void | Promise<void>} props.onSave
 * @param {() => void} props.onCancel
 * @param {string} [props.triggeringKey]
 * @param {boolean} [props.isPlanRail]
 */
export function NewTaskInputRow({
  onSave,
  onCancel,
  triggeringKey,
  isPlanRail,
}) {
  const input = (
    <TaskInputInline
      onSave={onSave}
      onCancel={onCancel}
      triggeringKey={triggeringKey}
      dense={!isPlanRail}
    />
  );
  return isPlanRail ? (
    <AddTaskInputRow className="new-task-input-row">{input}</AddTaskInputRow>
  ) : (
    input
  );
}
